import {_utils} from "../../../utils/_utils.js";
import {_libs} from "../../../utils/_libs.js";
import {_state} from "../../../state/state.js";

export const recentWork = () => {
    return new Promise((resolve) => {
        _utils.initSection('.recent-work', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    initSlider(section);
    initPopup(section);
};

const initSlider = (section) => {
    const sliderEl = section.querySelector('.recent-work__slider');
    if (!sliderEl) return;

    const slides = sliderEl.querySelectorAll('.recent-work__slide');
    if (slides.length <= 1) return;

    const prevEl = section.querySelector('.recent-work__arrow--prev');
    const nextEl = section.querySelector('.recent-work__arrow--next');
    const paginationEl = section.querySelector('.recent-work__pagination');

    _libs._swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 600,
        grabCursor: true,
        keyboard: {
            enabled: true,
        },
        navigation: {
            prevEl,
            nextEl,
        },
        pagination: {
            el: paginationEl,
            type: 'fraction',
        },
        breakpoints: {
            990: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },
    });
};

// Compare popup — opened from a card's "+" button, shows a before/after drag slider.
const initPopup = (section) => {
    const popup = section.querySelector('[data-rw-popup]');
    if (!popup) return;

    const openButtons = [...section.querySelectorAll('[data-rw-open]')];
    const closeEls = [...popup.querySelectorAll('[data-rw-close]')];
    const compares = [...popup.querySelectorAll('.recent-work__compare')];

    compares.forEach(initCompare);

    let isOpen = false;

    // Scroll lock: stop the Lenis smooth-scroll instance (desktop) + the theme's
    // overflow-hidden class (handles native/touch scroll on mobile, where Lenis is off).
    const lockScroll = (lock) => {
        document.documentElement.classList.toggle('overflow-hidden', lock);
        document.body.classList.toggle('overflow-hidden', lock);
        if (_state.lenisInit) {
            lock ? _state.lenisInit.stop() : _state.lenisInit.start();
        }
    };

    const open = (index) => {
        compares.forEach((c) => {
            const isActive = Number(c.dataset.rwCompare) === index;
            c.classList.toggle('is-active', isActive);
            if (isActive) {
                c.style.setProperty('--pos', '50%');
            }
        });
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        lockScroll(true);
        isOpen = true;
    };

    const close = () => {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        lockScroll(false);
        compares.forEach((c) => c.classList.remove('is-active'));
        isOpen = false;
    };

    openButtons.forEach((btn) => {
        btn.addEventListener('click', () => open(Number(btn.dataset.rwOpen)));
    });

    closeEls.forEach((el) => el.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
        if (isOpen && e.key === 'Escape') close();
    });
};

// Before/after drag comparison driven by the --pos CSS variable (0%..100%).
const initCompare = (compare) => {
    const setPos = (clientX) => {
        const rect = compare.getBoundingClientRect();
        let pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        compare.style.setProperty('--pos', pct + '%');
    };

    compare.addEventListener('pointerdown', (e) => {
        compare.setPointerCapture(e.pointerId);
        compare.classList.add('is-dragging');
        setPos(e.clientX);
    });

    compare.addEventListener('pointermove', (e) => {
        if (!compare.hasPointerCapture(e.pointerId)) return;
        setPos(e.clientX);
    });

    const release = (e) => {
        if (compare.hasPointerCapture(e.pointerId)) {
            compare.releasePointerCapture(e.pointerId);
        }
        compare.classList.remove('is-dragging');
    };
    compare.addEventListener('pointerup', release);
    compare.addEventListener('pointercancel', release);
};
